import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {
  MenuItem,
  menuItems,
  menuItemsBroker,
  menuItemsMaster,
  menuItemsMasterDev,
} from '../../const/menu-items';
import { errorHandler } from '../../helpers/error-handler';
import { AuthService } from '../../services/auth.service';
import { CoreService } from '../../services/core.service';
import { SecurityService } from '../../services/security.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../../environments/environment';
import { IntegrationsService } from '../../services/integrations.services';
import { InspectionService } from '../../services/inspection.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  showSubmenu: boolean = true;
  items: MenuItem[];
  openedItem: MenuItem | { label: string; icon: string; profile: boolean };
  user: any = null;
  openedSubmenuMobile: boolean = false;
  isEnableEditUser: boolean = false;
  companiesToSelect: any[] = [{ name: 'Planetun' }, { name: 'Subsidiaria 1' }];
  selectedCompany = this.companiesToSelect[0];
  profile: any = '';
  form: FormGroup;
  formPassword: FormGroup;
  genderValues: any[] = [
    { id: 0, name: 'Masculino' },
    { id: 1, name: 'Feminino' },
  ];
  myData: boolean = false;
  myPassword: boolean = false;
  environmentQa: boolean;
  hasAccessWorkFlow: boolean;
  hasAccessDashboard: boolean;
  profileName: any;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private securityService: SecurityService,
    public coreService: CoreService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private userService: UserService,
    private instegrationService: IntegrationsService,
    private serviceCompany: InspectionService
  ) {
    this.returnProfile();
  }

  ngOnDestroy(): void {
    // this.loadMenu(this.coreService.companyInfo);
  }

  logoutSSO() {
    console.log ("Id Token armazenado para logout FFFFF  SSO:", sessionStorage.getItem("kc_id_token"));
    const idToken = sessionStorage.getItem("kc_id_token"); // você deve armazená-lo
    console.log("ID Token para logout SSO:", idToken);
    const redirectUri = encodeURIComponent(`${window.location.origin}`);
    console.log("Redirect URI para logout SSO:", redirectUri);
    const url = 
      `${environment.keyCloakLogoutUrl}?` +
      `client_id=hub` +
      `&post_logout_redirect_uri=${redirectUri}` +
      (idToken ? `&id_token_hint=${idToken}` : "");
    console.log("URL de logout SSO:", url);
    // limpa storage local
    localStorage.clear();
    sessionStorage.clear();

    // redireciona
    window.location.href = url;
  }

  async returnProfile() {
    const decode = this.authService.getDecodedToken();
    this.profile = this.coreService.getProfileName(decode.Profile);
  }

  async ngOnInit() {
    this.items = [];

    console.log ("Id Token armazenado para logout SSO:", sessionStorage.getItem("kc_id_token"));

    let id;

    if (this.provider) {
      id = this.provider.id
    } else if (this.insurance.isBroker && this.insurance.isExternalAccess) {
      id = this.insurance.id
    } else {
      id = this.insurance.companyId
    }

    let companyInfo = this.coreService.companyInfo;

    this.loadMenu(companyInfo);

    const MobiUser = (await this.userService.getByIdPerson(this.userId)).body;

    if (
      MobiUser.companyPerson[0]['MobiUser'] == null ||
      MobiUser.companyPerson[0]['MobiUser'] == undefined ||
      MobiUser.companyPerson[0]['MobiUser'] == '' ||
      MobiUser.companyPerson[0]['MobiUser'].lenght == 0
    ) {
      this.hasAccessWorkFlow =
        companyInfo.companyName.toLowerCase().includes('suhai') &&
        (this.profile == 'Master' ||
          this.profile === 'Master Cliente' ||
          this.profile == 'Prestador Interno' ||
          this.profile == 'Intermediário' ||
          this.profile == 'Master Dev');

      this.hasAccessDashboard =
        !companyInfo.companyName.toLowerCase().includes('mapfre') &&
        !companyInfo.companyName.toLowerCase().includes('bb') &&
        this.profile != 'Intermediário' &&
        this.profile != 'Básico Intermediário';
      if (this.profile.toLowerCase().includes('corretor')) {
        this.hasAccessDashboard = false;
      }
    }

    this.authService.user$.subscribe((user) => (this.user = user));
    this.formProfile();
    this.formProfilePassword();
    const infoUser = (await this.userService.getByIdPerson(this.userId)).body;
    this.form.patchValue(infoUser);
    this.formPassword.patchValue(infoUser);
    this.environmentQa = environment.qa;
  }

  reloadItems() {
    this.loadMenu(this.coreService.companyInfo);
  }

  loadMenu(companyInfo) {
    this.items = [];

    if (this.insurance.isExternalAccess) return;

    if (companyInfo.isBroker) {
      this.items = menuItemsBroker;
      this.items[0].subitems.forEach(x => {
        if (x.label === 'Vistoria') {
          if (!x.subitems.find(({ label }) => label === 'Fila de Agendamento')) {
            console.log('passou 1')
            x.subitems.push(this.createSchedulingQueue());
            x.subitems.sort((a, b) => (a.label < b.label ? -1 : 1));
          }
        }
      })
    } else if (this.profile === 'Master' || this.profile === 'Master Cliente') {
      this.items = menuItemsMaster;
      this.items[0].subitems.forEach(x => {
        if (x.label === 'Vistoria') {
          console.log('passou 2')
          if (!x.subitems.find(({ label }) => label === 'Fila de Agendamento')) {
            x.subitems.push(this.createSchedulingQueue());
            x.subitems.sort((a, b) => (a.label < b.label ? -1 : 1));
          }
        }
      })
    } else if (this.profile === 'Master Cliente') {
      console.log('passou 3')
      this.items = menuItemsMaster;
      this.items[0].subitems.forEach(x => {
        if (x.label === 'Vistoria') {
          if (!x.subitems.find(({ label }) => label === 'Fila de Agendamento')) {
            x.subitems.push(this.createSchedulingQueue());
            x.subitems.sort((a, b) => (a.label < b.label ? -1 : 1));
          }
        }
      })
    } else if (this.profile === 'Master Dev') {
      console.log('passou 4')
      this.items = menuItemsMasterDev;
      this.items[0].subitems.forEach(x => {
        if (x.label === 'Vistoria') {
          if (!x.subitems.find(({ label }) => label === 'Fila de Agendamento')) {
            x.subitems.push(this.createSchedulingQueue());
            x.subitems.sort((a, b) => (a.label < b.label ? -1 : 1));
          }
        }
        // TODO: Mudar a logica === para !== quando o Master DEV liberar para Sura
        if (x.label === 'Suporte' && companyInfo.companyId !== '229a8f96-2d04-41c7-b498-ae8698690066') {
          x.subitems = x.subitems.filter(
            (y) => y.label !== 'Importar Código Corretor'
          );
        }
      })
    } else {
      this.items = menuItems;
      this.items[0].subitems.forEach(x => {
        if (x.label === 'Vistoria') {
          console.log('passou 5')
          if (!x.subitems.find(({ label }) => label === 'Fila de Agendamento')) {
            x.subitems.push(this.createSchedulingQueue());
            x.subitems.sort((a, b) => (a.label < b.label ? -1 : 1));
          }
        }
      })
      if (
        this.profile === 'Prestador Terceirizado' ||
        this.profile === 'Prestador Terceirizado Master'
      ) {
        this.items[0].subitems.forEach((x, i) => {
          if (x.claim === 'company' && x.label === 'Dashboard') {
            this.items[0].subitems.splice(i, 1);
          }
          if (x.claim === 'inspection') {
            x.subitems = x.subitems.filter(
              (y) => y.label !== 'Cadastro de Vistoria'
            );
          }
        });
      }
    }

    let id;

    if (this.provider) {
      id = this.provider.id
    } else if (this.insurance.isBroker && this.insurance.isExternalAccess) {
      id = this.insurance.id
    } else {
      id = this.insurance.companyId
    }

    // se for Planetun Prestador
    if (this.insurance.companyId === 'b8b08256-cfe6-497d-a48e-bd039662c5e6') {
      if (this.provider &&
        this.provider.id.toLowerCase() !== '79c206c7-021c-489f-8fd1-6f985faa1343' &&
        this.provider.id.toLowerCase() !== 'f00c37cc-accf-48c7-8c21-50b63f32d1c1' &&
        this.provider.id.toLowerCase() !== '9dab929f-d81b-40bc-89db-633aa0f1b098') {
          console.log('passou 6')
        this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
      } else {
        if (
          this.profile !== 'Master' &&
          this.profile !== 'Master Dev' &&
          this.profile !== 'Master Cliente' &&
          this.profile !== 'Prestador Terceirizado' &&
          this.profile !== 'Prestador Terceirizado Master') {
            console.log('passou 7')
          this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
        }
      }
    } else if (this.insurance.companyId.toLowerCase() === 'f00c37cc-accf-48c7-8c21-50b63f32d1c1' || this.insurance.companyId.toLowerCase() === '79c206c7-021c-489f-8fd1-6f985faa1343') {
      this.serviceCompany.getCompanyById(id).then(x => {
        let insId = x.insuranceCompany.id;
        if (insId !== null || insId !== undefined) {
          if (insId.toLowerCase() !== '25511351-5b52-42ba-9cf6-9a5bd9b3570a' && insId.toLowerCase() !== '1a3bc78c-d214-4e52-a140-9cae19ee2ab9') {
            console.log('passou 8')
            this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
          } else {
            if (
              this.profile !== 'Master' &&
              this.profile !== 'Master Dev' &&
              this.profile !== 'Master Cliente' &&
              this.profile !== 'Prestador Terceirizado' &&
              this.profile !== 'Prestador Terceirizado Master') {
              this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
            }
          }
        }

        if (this.provider !== null) {

          if (insId.toLowerCase() !== '25511351-5b52-42ba-9cf6-9a5bd9b3570a' && insId.toLowerCase() !== '1a3bc78c-d214-4e52-a140-9cae19ee2ab9' && this.provider.id !== 'b8b08256-cfe6-497d-a48e-bd039662c5e6') {
            console.log('passou 9')
            this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
          }
        }
      })

    } else if (this.insurance.companyId.toLowerCase() === '2a581b6b-d6b0-4d84-af2a-c37c5527f25a') {
      this.serviceCompany.getCompanyById(id).then(x => {
        if (
          this.profile !== 'Master' &&
          this.profile !== 'Master Dev' &&
          this.profile !== 'Master Cliente' &&
          this.profile !== 'Prestador Terceirizado' &&
          this.profile !== 'Prestador Terceirizado Master') {
            console.log('passou 10')
          this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
        }
      })
    } else if (['c1db8823-6960-4555-a354-eee9c31404a5', '9dab929f-d81b-40bc-89db-633aa0f1b098'].includes(this.insurance.companyId.toLowerCase())) {
      this.serviceCompany.getCompanyById(id).then(x => {
        if (
          this.profile !== 'Master' &&
          this.profile !== 'Master Dev' &&
          this.profile !== 'Master Cliente' &&
          this.profile !== 'Prestador Terceirizado' &&
          this.profile !== 'Prestador Terceirizado Master') {
            console.log('passou 10')
          this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
        }
      })
    }else {
      console.log('passou 11', this.profile)
      this.removeSubitemByLabel(this.items[0], 'Fila de Agendamento');
    }
  }

  async ngAfterViewInit() {
    this.loadMenu(this.coreService.companyInfo);

  }

  closeAll(item?) {
    this.recursivellyCloseItem(this.items);
    this.openedItem = null;
    this.coreService.callSideBar(item);
  }

  private recursivellyCloseItem(items: MenuItem[]) {
    if (!items?.length) {
      return;
    }
    items.forEach((item) => {
      item.opened = false;
      this.recursivellyCloseItem(item.subitems);
    });
  }

  openItem(item: MenuItem) {
    this.closeAll(item);
    do {
      item.opened = true;
      this.openedItem = item;
      item = item.parent;
    } while (item);
  }

  toggleSubmenuMobile() {
    this.openedSubmenuMobile = !this.openedSubmenuMobile;
  }

  openProfile() {
    this.closeAll();
    this.openedItem = {
      icon: 'account_circle',
      label: 'Meu Perfil',
      profile: true,
    };
  }

  backMenuItem() {
    if ((this.openedItem as MenuItem)?.parent) {
      this.openItem((this.openedItem as MenuItem).parent);
    } else {
      this.closeAll();
    }
  }

  toggleSubMenu() {
    this.closeAll();
  }

  async logout() {
    
    await this.authService.logout();
    await this.logoutSSO();
    
  }

  async toggleEditUser() {
    this.isEnableEditUser = this.isEnableEditUser;
  }

  selectCompany(company: any) {
    this.selectedCompany = company;
  }

  get insurance() {
    const value = JSON.parse(window.localStorage.getItem('insurance'));
    return value.company;
  }

  get userId() {
    const value = JSON.parse(window.localStorage.getItem('insurance'));
    return value.personId;
  }

  get provider() {
    const value = JSON.parse(window.localStorage.getItem('provider'));
    return value;
  }

  getAccess(item: any) {
    if (item.label == 'Cadastro de Vistoria') {
      const res = this.securityService.hasClaim(item.claim, 'add');
      return res;
    } else {
      const res = this.securityService.hasClaim(item.claim, 'get');
      return res;
    }
  }

  formProfile() {
    this.form = this.fb.group({
      id: ['', [Validators.required]],
      existentPerson: [''],
      fullName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      document: [''],
      gender: [''],
      personStatus: [''],
      office: [''],
      area: [''],
      phone: [''],
    });
  }

  formProfilePassword() {
    this.formPassword = this.fb.group({
      currentPassword: [''],
      newPassword: [''],
      confirmPassword: [''],
    });
  }

  async save() {
    if (this.form.invalid) {
      return false;
    } else {
      this.putForm();
    }
  }

  async savePassword() {
    if (this.formPassword.invalid) {
      return false;
    } else {
      this.putFormPassword();
    }
  }

  async putForm() {
    this.spinner.show();
    try {
      let valuesForm = this.form.value;
      const resultProvider = await this.userService.editPersonId(
        this.userId,
        valuesForm
      );
      this.toastr.success('Usuário com sucesso!', 'Sucesso!');
    } catch (error) {
      this.toastr.error(errorHandler(error), 'Erro!');
    } finally {
      this.spinner.hide();
    }
  }

  get fToken() {
    return this.formPassword.controls;
  }

  confirmPassword() {
    if (this.fToken.newPassword.value === this.fToken.confirmPassword.value) {
      return true;
    }
    return false;
  }

  async putFormPassword() {
    this.spinner.show();
    try {
      let valuesForm = this.formPassword.value;

      const resultProvider = await this.userService.changePassword(valuesForm);
      this.toastr.success('Senha alterada com sucesso!', 'Sucesso!');
      this.myPassword = false;
      this.formPassword.reset();
    } catch (error) {
      this.toastr.error(errorHandler(error), 'Erro!');
    } finally {
      this.myPassword = false;
      this.spinner.hide();
    }
  }

  changeData() {
    this.myData = !this.myData;
    this.myPassword = false;
  }

  changePassword() {
    this.myPassword = !this.myPassword;
    this.myData = false;
  }

  validatePassword(value) {
    if (
      !this.hasLowerCase(value) ||
      !this.hasUpperCase(value) ||
      !this.hasNumber(value) ||
      !this.hasSpecial(value)
    ) {
      return false;
    }
    return true;
  }

  hasLowerCase(str) {
    if (str) {
      return str.toUpperCase() != str;
    }
  }

  hasUpperCase(str) {
    return str.toLowerCase() != str;
  }

  hasNumber(str) {
    return /\d/.test(str);
  }

  hasSpecial(str) {
    var iChars = '~`!#$%^&@*+=-[]\\\';,/{}|":<>?';

    for (var i = 0; i < str.length; i++) {
      if (iChars.indexOf(str.charAt(i)) != -1) {
        return true;
      }
    }
    return false;
  }

  handleNameProfile(): string {
    if (this.insurance.isProvider) return 'Prestadora';
    else if (this.insurance.isBroker) return 'Corretora';
    else return 'Seguradora';
  }

  async openExternalLink(item: any) {

    if (item.label === 'Fila de Agendamento') {
      window.open(item.route, '_blank');
    }

    var resultMoby = await this.instegrationService.getMobyTokenViewInspections(
      this.coreService.insuranceInfo.id
    );

    const resultMobyToken = resultMoby.body;
    var tokenMobi = resultMobyToken.token;

    if (item.label === 'Workflow') {
      let uriWorkFlow = `${environment.mobiLinkWorkflow}=${tokenMobi}`;
      window.open(uriWorkFlow);
    } else if (item.label !== 'Fila de Agendamento') {
      let uriDashboard = `${environment.mobiDashBoardUri}=${tokenMobi}`;
      window.open(uriDashboard);
    }
  }

  removeSubitemByLabel(menu: MenuItem, labelToRemove: string): void {
    if (menu.subitems) {
      menu.subitems = menu.subitems.filter(subitem => subitem.label !== labelToRemove);
      menu.subitems.forEach(subitem => this.removeSubitemByLabel(subitem, labelToRemove));
    }
  }

  createSchedulingQueue(): MenuItem {
    return new MenuItem({
      label: 'Fila de Agendamento', claim: 'inspection', route: '/handle'
    });
  }

}
